import { useState } from "react";
import KpiList from "../components/KpiList";
import "../styles/dashboard.css";

export default function PimpinanView({ user }) {
  const [tahun, setTahun] = useState("2025");
  const [isPrintMode, setIsPrintMode] = useState(false);

  const handlePrint = () => {
    setIsPrintMode(true);
    setTimeout(() => {
      window.print();
      setIsPrintMode(false);
    }, 500);
  };

  return (
    <div className={`dashboard ${isPrintMode ? "print-mode" : ""}`}>
      <section className="panel pimpinan-panel">
        <div className="header-section">
          <div>
            <h2 className="welcome-title">Selamat datang, {user.company}</h2>
            <p className="welcome-subtitle">Dashboard Monitoring KPI</p>
          </div>
          <div className="action-buttons">
            <button className="print-button" onClick={handlePrint}>
              Cetak Laporan
            </button>
          </div>
        </div>

        <div className="tahun-selector">
          <label className="select-label">Pilih Periode</label>
          <select
            value={tahun}
            onChange={(e) => setTahun(e.target.value)}
            className="modern-select"
          >
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
            <option value="2030">2030</option>
          </select>
        </div>

        <div className="kpi-section">
          <div className="section-header">
            <h3 className="section-title">Data KPI Anda</h3>
            <span className="tahun-badge">
              {tahun.replace("_", " ").toUpperCase()}
            </span>
          </div>
          <KpiList perusahaan={user.company} tahun={tahun} role={user.role} />
        </div>
      </section>
    </div>
  );
}
